import { BinderConfigurator, ComponentTagMappings, SamePropertyNamesBinder, ViewGenerator } from "binder";
import moment from "moment";
import { MainWindowView } from "./common/mainWindow/mainWindow-view";
import { MainWindowViewModel } from "./common/mainWindow/mainWindow-viewModel";
import { Converters } from "./converters";
import { TranslatorConverter } from "./TranslatorConverter";
declare var persianDate:any;

window.onload = function(){
    persianDate.toLeapYearMode('astronomical');
    if(screen.width > 800) {
        var vp = document.querySelector('meta[name="viewport"]');
        vp.setAttribute('content','width=device-width, initial-scale=0.8');
    }
    require('uicomponents');

    new BinderConfigurator().pushConverterRepository(new Converters());
    new BinderConfigurator().pushConverterRepository(new TranslatorConverter());
    let viewModel = new MainWindowViewModel(null);
    let view = new MainWindowView();
    view.dataContext = viewModel;
    SamePropertyNamesBinder.bindSourceAndDestination(viewModel,view);
    let html = ViewGenerator.GetHtml(view);
    const mainPageDiv = document.getElementById('mainPageDiv');
    mainPageDiv.appendChild(html);
    view.onRenderCompleted();
}
